import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { updateSelectedProductAction } from '../../../actions/instances/products';
import CreateSelectModal from '../../Modals/CreateSelectModal/CreateSelectModal';
import CreateProductModal from '../../Modals/Content/Products/CreateProductModal/CreateProductModal';
import SelectProductModal from '../../Modals/Content/Products/SelectProductModal/SelectProductModal';
import './ProductsCardsList.scss';

const ProductsCardsList = ({
  products,
  onItemAdded,
  isLoading,
  cityId,
  dynastyId,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [productsInlineEditingShown, setProductsInlineEditingShown] = useState(false);
  const navigateToProduct = (product) => {
    dispatch(updateSelectedProductAction(product));
    history.push('/instances/building-products/view');
  };
  const itemSelected = (component) => {
    if (onItemAdded) {
      onItemAdded(component);
    }
    setProductsInlineEditingShown(false);
  };
  return (
    <>
      <CreateSelectModal
        title="Create or select a product"
        createView={(
          <CreateProductModal
            onItemCreated={comp => itemSelected(comp)}
            city={cityId}
            dynasty={dynastyId}
          />
        )}
        selectView={<SelectProductModal onItemSelected={comp => itemSelected(comp)} />}
        onRequestClose={() => setProductsInlineEditingShown(false)}
        isShown={productsInlineEditingShown}
      />
      <section className="widget sidebar-list-widget">
        <h3 className="title">Products</h3>
        <div className="list">
          {(products && !isLoading) && products.map(product => (
            <div className="item" onClick={() => navigateToProduct(product)}>
              {product.images.length > 0 ? (
                <img alt={product.name} src={product.images[0].url} />
              ) : (
                <img alt={product.name} src="/images/default.jpg" />
              )}
              <button type="button">
                <strong>NAME: </strong>
                {product.name}
                <br />
                <strong>CODE: </strong>
                {product.code}
              </button>
            </div>
          ))}
          {(products.length === 0 && !isLoading) && (
            <p>No products were found for this building.</p>
          )}
          {isLoading && (
            <div className="row w-100">
              <div className="col-md-12 d-flex justify-content-center">
                <Spinner />
              </div>
            </div>
          )}
        </div>
        <div className="actions">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a href="#" onClick={() => setProductsInlineEditingShown(true)}>
            Link to Product
          </a>
        </div>
      </section>
    </>
  );
};

ProductsCardsList.propTypes = {
  products: PropTypes.array.isRequired,
  onItemAdded: PropTypes.func,
  isLoading: PropTypes.bool,
  cityId: PropTypes.number,
  dynastyId: PropTypes.number,
};

ProductsCardsList.defaultProps = {
  onItemAdded: undefined,
  isLoading: false,
  cityId: undefined,
  dynastyId: undefined,
};

export default ProductsCardsList;
